import {Box} from "@mui/material"
import React from "react"

export const widgetEmptyPrototype = [
    {
        key: "bgcolor",
        type: "COLOR",
        label: "Hintergrundfarbe",
        size: 3,
    },
    {
        key: "height",
        type: "INTEGER",
        label: "Höhe in px",
        size: 3,
    },
    {
        key: "width",
        type: "INTEGER",
        label: "Breite in px",
        size: 3,
    },
]

const WidgetEmpty = ({widget}) => {
    return (
        <Box
            width={widget.width ? widget.width + "px" : "100%"}
            height={widget.height ? widget.height + "px" : "24px"}
            bgcolor={widget.bgcolor ?? ""}
        />
    )
}

export default WidgetEmpty
